export default function Burguer(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
    >
      <path
        d="M2 24C1.43334 24 0.958673 23.808 0.576007 23.424C0.19334 23.04 0.00134023 22.5653 6.89654e-06 22C-0.00132644 21.4346 0.190674 20.96 0.576007 20.576C0.961339 20.192 1.43601 20 2 20H34C34.5666 20 35.042 20.192 35.426 20.576C35.81 20.96 36.0013 21.4346 36 22C35.9986 22.5653 35.8066 23.0406 35.424 23.426C35.0413 23.8113 34.5666 24.0026 34 24H2ZM2 14C1.43334 14 0.958673 13.808 0.576007 13.424C0.19334 13.04 0.00134023 12.5653 6.89654e-06 12C-0.00132644 11.4347 0.190674 10.96 0.576007 10.576C0.961339 10.192 1.43601 9.99999 2 9.99999H34C34.5666 9.99999 35.042 10.192 35.426 10.576C35.81 10.96 36.0013 11.4347 36 12C35.9986 12.5653 35.8066 13.0407 35.424 13.426C35.0413 13.8113 34.5666 14.0027 34 14H2ZM2 4C1.43334 4 0.958673 3.808 0.576007 3.424C0.19334 3.04 0.00134023 2.56533 6.89654e-06 2C-0.00132644 1.43467 0.190674 0.959999 0.576007 0.576C0.961339 0.192 1.43601 0 2 0H34C34.5666 0 35.042 0.192 35.426 0.576C35.81 0.959999 36.0013 1.43467 36 2C35.9986 2.56533 35.8066 3.04066 35.424 3.426C35.0413 3.81133 34.5666 4.00266 34 4H2Z"
        fill="#0A1B2F"
      />
    </svg>
  );
}
